module.exports = __webpack_public_path__ + "img/bs.4eea8968.svg";